export default "__VITE_ASSET__EXmRkpz2__"